import type { ContentType } from '~/models/Content/ContentType'
import type { BaseItem } from '~/models/Content/BaseItem'
import { useI18n } from '~/composables/useI18n'

export function useContentType() {
  const { t } = useI18n()
  const getName = (resource: BaseItem): string => getNameByContentTypeIdentifier(resource.contentTypeIdentifier)

  const getNameByContentTypeIdentifier = (contentType: ContentType): string => {
    const translation: string = t(`contentTypes.${contentType}`)
    if (translation.includes('contentTypes')) {
      console.warn(`No translation found for content type "${contentType}"`)
      return t('contentTypes.default')
    }
    return translation
  }

  return {
    getName,
    getNameByContentTypeIdentifier,
  }
}
